import { render } from "./BaseButton.vue?vue&type=template&id=621d32da&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=621d32da&scoped=true&lang=css"

import exportComponent from "D:\\Users\\וינברג\\Documents\\Vue\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-621d32da"]])

export default __exports__